// İş Planlama ortak sabitleri. Tailwind sınıfları literal yazılır (purge korusun).
// Contract: BayinerIOT-Workspace-/docs/api-contracts/tasks.md
import { format, formatDistanceToNow, isValid } from "date-fns";
import trLocale from "date-fns/locale/tr";

export const STATUSES = [
  { id: "todo", label: "Yapılacak", className: "bg-gray-100 text-gray-700" },
  { id: "in_progress", label: "Devam Ediyor", className: "bg-blue-50 text-blue-700" },
  { id: "in_review", label: "Kontrolde", className: "bg-amber-50 text-amber-700" },
  { id: "done", label: "Bitti", className: "bg-green-50 text-green-700" },
  { id: "cancelled", label: "İptal", className: "bg-red-50 text-red-700" },
];

export const PRIORITIES = [
  { id: "low", label: "Düşük", className: "text-gray-500" },
  { id: "medium", label: "Orta", className: "text-blue-600" },
  { id: "high", label: "Yüksek", className: "text-orange-500" },
  { id: "urgent", label: "Acil", className: "text-red-600" },
];

export const TYPES = [
  { id: "task", label: "Görev", className: "bg-blue-50 text-blue-700" },
  { id: "bug", label: "Hata", className: "bg-red-50 text-red-700" },
  { id: "improvement", label: "İyileştirme", className: "bg-emerald-50 text-emerald-700" },
];

// Etiket / proje renk anahtarı (server paleti) -> Tailwind sınıfları
export const COLOR_CLASSES = {
  gray: "bg-gray-100 text-gray-700",
  red: "bg-red-50 text-red-700",
  orange: "bg-orange-50 text-orange-700",
  amber: "bg-amber-50 text-amber-700",
  yellow: "bg-yellow-50 text-yellow-700",
  lime: "bg-lime-50 text-lime-700",
  green: "bg-green-50 text-green-700",
  emerald: "bg-emerald-50 text-emerald-700",
  teal: "bg-teal-50 text-teal-700",
  cyan: "bg-cyan-50 text-cyan-700",
  sky: "bg-sky-50 text-sky-700",
  blue: "bg-blue-50 text-blue-700",
  indigo: "bg-indigo-50 text-indigo-700",
  violet: "bg-violet-50 text-violet-700",
  purple: "bg-purple-50 text-purple-700",
  fuchsia: "bg-fuchsia-50 text-fuchsia-700",
  pink: "bg-pink-50 text-pink-700",
  rose: "bg-rose-50 text-rose-700",
};

// Renk seçici noktaları için güçlü tonlar (rozetlerin açık zemini seçicide birbirine benziyor)
export const SWATCH_CLASSES = {
  gray: "bg-gray-500",
  red: "bg-red-500",
  orange: "bg-orange-500",
  amber: "bg-amber-500",
  yellow: "bg-yellow-500",
  lime: "bg-lime-500",
  green: "bg-green-500",
  emerald: "bg-emerald-500",
  teal: "bg-teal-500",
  cyan: "bg-cyan-500",
  sky: "bg-sky-500",
  blue: "bg-blue-500",
  indigo: "bg-indigo-500",
  violet: "bg-violet-500",
  purple: "bg-purple-500",
  fuchsia: "bg-fuchsia-500",
  pink: "bg-pink-500",
  rose: "bg-rose-500",
};

export const colorClass = (color) => COLOR_CLASSES[color] || COLOR_CLASSES.gray;

// Pano kartı proje çerçevesi: kartı saran renkli kenar + tam genişlik renkli başlık
// şeridi; gövde beyaz. Sınıflar Tailwind JIT için literal.
export const PROJECT_FRAME_CLASSES = {
  gray: { frame: "border-gray-300", header: "bg-gray-100 text-gray-800" },
  red: { frame: "border-red-300", header: "bg-red-100 text-red-800" },
  orange: { frame: "border-orange-300", header: "bg-orange-100 text-orange-800" },
  amber: { frame: "border-amber-300", header: "bg-amber-100 text-amber-800" },
  yellow: { frame: "border-yellow-300", header: "bg-yellow-100 text-yellow-800" },
  lime: { frame: "border-lime-300", header: "bg-lime-100 text-lime-800" },
  green: { frame: "border-green-300", header: "bg-green-100 text-green-800" },
  emerald: { frame: "border-emerald-300", header: "bg-emerald-100 text-emerald-800" },
  teal: { frame: "border-teal-300", header: "bg-teal-100 text-teal-800" },
  cyan: { frame: "border-cyan-300", header: "bg-cyan-100 text-cyan-800" },
  sky: { frame: "border-sky-300", header: "bg-sky-100 text-sky-800" },
  blue: { frame: "border-blue-300", header: "bg-blue-100 text-blue-800" },
  indigo: { frame: "border-indigo-300", header: "bg-indigo-100 text-indigo-800" },
  violet: { frame: "border-violet-300", header: "bg-violet-100 text-violet-800" },
  purple: { frame: "border-purple-300", header: "bg-purple-100 text-purple-800" },
  fuchsia: { frame: "border-fuchsia-300", header: "bg-fuchsia-100 text-fuchsia-800" },
  pink: { frame: "border-pink-300", header: "bg-pink-100 text-pink-800" },
  rose: { frame: "border-rose-300", header: "bg-rose-100 text-rose-800" },
};
export const projectFrame = (color) => PROJECT_FRAME_CLASSES[color] || PROJECT_FRAME_CLASSES.gray;

const byId = (list) => (id) => list.find((x) => x.id === id);
export const getStatus = byId(STATUSES);
export const getPriority = byId(PRIORITIES);
export const getType = byId(TYPES);

export const userName = (u) => (u ? `${u.name || ""} ${u.lastName || ""}`.trim() : "");

export const initials = (u) => {
  if (!u) return "?";
  const a = (u.name || "").trim().charAt(0);
  const b = (u.lastName || "").trim().charAt(0);
  return (a + b).toLocaleUpperCase("tr-TR") || "?";
};

// Sunucuyla aynı gecikme kuralı: bitiş GÜNÜ, bugünün gününden (Europe/Istanbul,
// UTC+3, yaz saati yok) önceyse ve iş bitti/iptal değilse gecikmiştir. Bugün biten gecikmiş değil.
const ISTANBUL_OFFSET_MS = 3 * 60 * 60 * 1000;
export const istanbulToday = (now = Date.now()) => new Date(now + ISTANBUL_OFFSET_MS).toISOString().slice(0, 10);

// 1.7 — arşiv: "biten iş" incelemede / tamamlandı / iptal (incelemedeki arşive giderken tamamlandı olur).
export const FINISHED_STATUSES = ["in_review", "done", "cancelled"];
export const ARCHIVE_STATUS_MESSAGE = "Yalnız biten (incelemede, tamamlanan veya iptal edilen) işler arşivlenebilir.";
export const ARCHIVE_SUBTASKS_MESSAGE = "Tüm alt işler bitmeden üst iş arşivlenemez.";

/** Arşive atılamıyorsa nedeni (sunucu mesajıyla aynı), atılabiliyorsa null. */
export const archiveBlockReason = (task) => {
  if (!task || task.archivedAt) return null;
  if (!FINISHED_STATUSES.includes(task.status)) return ARCHIVE_STATUS_MESSAGE;
  if ((task.subtasks || []).some((s) => !FINISHED_STATUSES.includes(s.status))) return ARCHIVE_SUBTASKS_MESSAGE;
  return null;
};

export const isOverdue = (task, now = Date.now()) => {
  if (!task || !task.dueDate) return false;
  if (task.status === "done" || task.status === "cancelled") return false;
  const due = toDayString(toDateOnly(task.dueDate));
  if (!due) return false;
  return due < istanbulToday(now);
};

// Ek yükleme sınırları (server ile aynı)
export const MAX_ATTACHMENT_SIZE = 26214400;
export const BLOCKED_EXTENSIONS = [
  "exe", "bat", "cmd", "com", "msi", "sh", "ps1", "js", "vbs", "jar", "apk", "app", "dmg", "scr",
];

export const formatFileSize = (bytes) => {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

// --- Tarih yardımcıları ---
// Başlangıç/bitiş "gün" alanıdır: ISO'nun yalnız YYYY-MM-DD kısmı yerel gün olarak okunur
// (saat dilimi kayması olmasın).
export const toDateOnly = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ""));
  if (!m) return null;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
};

// Date -> "YYYY-MM-DD" (sunucuya giden biçim); geçersiz/boş -> null
export const toDayString = (date) => (date && isValid(date) ? format(date, "yyyy-MM-dd") : null);

// ISO gün -> "dd.MM.yyyy"
export const formatDay = (iso) => {
  const d = toDateOnly(iso);
  return d ? format(d, "dd.MM.yyyy") : "";
};

// Zaman damgası (updatedAt vb.) -> yerel "dd.MM.yyyy"
export const formatDate = (iso) => {
  const d = iso ? new Date(iso) : null;
  return d && isValid(d) ? format(d, "dd.MM.yyyy") : "";
};

export const formatDateTime = (iso) => {
  const d = iso ? new Date(iso) : null;
  return d && isValid(d) ? format(d, "dd.MM.yyyy HH:mm") : "";
};

// "2 saat önce"
export const relativeTime = (iso) => {
  const d = iso ? new Date(iso) : null;
  return d && isValid(d) ? formatDistanceToNow(d, { addSuffix: true, locale: trLocale }).replace(/^yaklaşık /, "")
    : "";
};
